import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_CALENDARTYPES = "calendartypes";
const BASE_URL = "/api/calendartypes";

const CalendarTypesQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const CALENDARTYPES_EMPTY = {
    title:"",
   
};

export function useCalendarTypes() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CALENDARTYPES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...CalendarTypesQueryConfig
    });
    return {...result, calendartypes: result.data};
}


export function useCalendarType(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CALENDARTYPES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...CalendarTypesQueryConfig
    });
    return {...result, dmodel: result.data};
}

export function useCalendarTypeMutations() {
    async function createFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPOST(BASE_URL, dmodel, false);
    }

    async function editFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}`, dmodel);
    }

    async function editAddNewFiles(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}/files`, dmodel.fileId);
    }

    async function deleteFunction(dmodel) {
        return await fetchDELETE(`${BASE_URL}/${dmodel.id}`)
    }

    return {
        createCalendarType: useMyMutation(createFunction, REACT_QUERY_ID_CALENDARTYPES, dmodel => `CalendarType ${dmodel.title} created`),
        editCalendarType: useMyMutation(editFunction, REACT_QUERY_ID_CALENDARTYPES, dmodel => `CalendarType ${dmodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_CALENDARTYPES, dmodel => `CalendarType ${dmodel.title} modified`),
        deleteCalendarType: useMyMutation(deleteFunction, REACT_QUERY_ID_CALENDARTYPES, dmodel => `CalendarType ${dmodel.title} deleted.`)
    };

}